export default "__VITE_ASSET__DVVmiuJk__"